export default "__VITE_ASSET__vBclAkaa__"